const baseImgUrl = '//files.data100.com/web/'

export {baseImgUrl}